<template>
  <TextInputMultiline
    v-model="licenceText"
    :rows="6"
    :read-only="isTournamentFieldDisabled('licence_link')"
    :disabled="isTournamentFieldDisabled('licence_link')"
    has-counter
    :max-length="5000"
    :label="$t('_web_tournament_settings_licence-text-label', 'licence text:')"
    :placeholder="
      $t(
        '_web_tournament_settings_licence-text-placeholder',
        'Provide text licence for your tournament'
      )
    "
  />
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import TextInputMultiline from '@/components/molecules/form/TextInputMultilineWithActivators';
import { translate } from '@/mixins/translate';
const component = 'info';
export default {
  name: 'TournamentlicenceTextSetting',
  inject: ['$validator'],
  components: {
    TextInputMultiline,
  },
  mixins: [translate('_web_tournament_settings')],
  data() {
    return {
      licenceTextCopy: '',
    };
  },
  computed: {
    ...mapGetters([
      'currentTournament',
      'currentTournamentInfo',
      'isTournamentFieldDisabled',
    ]),
    componentData() {
      return this.currentTournamentInfo;
    },
    licenceText: {
      get() {
        return this.$lodash.get(this.componentData, 'license.text') || '';
      },
      set(newVal) {
        //Firefox feature, it inserts line break instead of new line symbol as in Chrome
        //so we just forcing Chrome like behaviour
        let fixedBRVal = newVal.replaceAll('<br>', '\n');

        this.updateCurrentTournament({
          license: { ...this.componentData.license, text: fixedBRVal },
          component,
        });
      },
    },
  },

  methods: {
    ...mapMutations(['updateCurrentTournament']),
    ...mapActions(['fetchTournamentLicenceText', 'errorNotify']),
  },
};
</script>
